<template>
  <div class="w-full h-full">
    <div class="flex justify-start item-start mb-10px mt-10px">
      <img src="../../../assets/images/titleIcon.png" alt="" />
      <span class="text-16px text-white custom-shadow ml-4px"> 质量安全问题列表 </span>
    </div>
    <div class="flex mb-10px">
      <el-select
        v-model="searchType"
        placeholder="选择类型"
        filterable
        clearable
        class="mr-5px"
        size="mini"
        popper-class="visualization-select-popper"
        @change="handleSearch"
      >
        <el-option v-for="item in typeOptions" :key="item" :label="item" :value="item"> </el-option>
      </el-select>
      <el-select
        v-model="searchStatus"
        placeholder="选择状态"
        filterable
        class="ml-5px"
        clearable
        size="mini"
        popper-class="visualization-select-popper"
        @change="handleSearch"
      >
        <el-option
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <el-table
      :data="problemList"
      height="calc(100% - 123px)"
      style="width: 100%"
      @row-click="handleRowClick"
      v-loading="tableLoading"
    >
      <el-table-column prop="subject" label="主题" show-overflow-tooltip></el-table-column>
      <el-table-column prop="type" label="类型" width="85"> </el-table-column>
      <el-table-column prop="flowStatus" label="状态" width="75"> </el-table-column>
      <el-table-column label="操作" width="55">
        <template #default="{row}">
          <div @click="viewDetail(row)" class="cursor-pointer text-[#409eff]">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @current-change="getTableData()"
      :current-page.sync="page.pageNum"
      :page-size.sync="page.pageSize"
      :pager-count="5"
      layout="total,prev, pager, next"
      :total="page.total"
      class="text-center mt-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { SafetyQualityApi } from '@wiz-api/haiguang'
import SafetyQuality from '../../../assets/js/componentMethods/safetyQuality'

const safetyQualityApi = new SafetyQualityApi()
export default {
  props: {
    cloudRender: {
      type: Object,
      defalut: null,
    },
    player: {
      type: Object,
      defalut: null,
    },
  },
  data() {
    return {
      searchType: '',
      searchStatus: '',
      typeOptions: [],
      statusOptions: [
        {
          value: null,
          label: '全部',
        },
        {
          value: '整改中',
          label: '整改中',
        },
        {
          value: '验收中',
          label: '验收中',
        },
        {
          value: '已完成',
          label: '已完成',
        },
      ],
      problemList: [],
      tableLoading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
    }
  },
  computed: {
    currentTenantId() {
      return (
        localStorage.getItem('CurrentTenantId') ||
        JSON.parse(localStorage.getItem('CurrentUser'))?.TenantId ||
        '8b53295c-b059-4caf-8fc6-4a1d9e7807e9'
      )
    },
  },
  created() {
    this.getTypeOptions()
    this.getTableData()
  },
  methods: {
    // 行点击
    async handleRowClick(row) {
      this.player.Native.ModelTree.restoreAllItemColor()
      if (row.kksCode) {
        const modelRes = await this.cloudRender.NodeProxy.getInfo('Code', row.kksCode)
        if (modelRes && modelRes.status && modelRes.data) {
          const itemAabb = await this.cloudRender.NodeProxy.getAabb(modelRes.data)
          if (itemAabb.status && itemAabb.data) {
            const mat = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
            this.player.Native.Camera.moveToAabb(
              { min: itemAabb.data.aabb[0], max: itemAabb.data.aabb[1] },
              mat,
              5,
              1.1,
              2
            )
            const colorEnum = {
              整改中: 0xff000080,
              验收中: 0xffa50080,
              已完成: 0x00ff0080,
            }
            this.player.Native.ModelTree.setItemColor(
              modelRes.data?.dataInfo.item,
              colorEnum[row.flowStatus]
            )
          }
        }
      }
    },
    // 查看详情
    viewDetail(row) {
      this.$emit('transferEvent', {
        toCom: {
          code: 'SafetyQualityDetail',
          origin: 'SafetyQualityManagement',
          name: '质量安全问题详情',
        },
        type: 'mainComponent',
        props: { problemId: row.problemId },
      })
    },
    // 获取类型列表
    async getTypeOptions() {
      const [err, res] = await safetyQualityApi.getSafetyQualityProblemTypeDict()
      if (!err) {
        this.typeOptions = res
      }
    },
    // 搜索
    handleSearch() {
      SafetyQuality.filterDisplay({
        type: this.searchType,
        flowStatus: this.searchStatus,
      })
      this.page.pageNo = 1
      this.getTableData()
    },
    // 获取列表
    async getTableData() {
      this.tableLoading = true
      const [err, res] = await safetyQualityApi.getSafetyQualityVisualProblemList({
        body: {
          maxResultCount: this.page.pageSize,
          skipCount: (this.page.pageNo - 1) * this.page.pageSize,
          projectId: this.currentTenantId,
          Type: this.searchType,
          FlowStatus: this.searchStatus,
        },
      })
      this.tableLoading = false
      if (!err) {
        this.problemList = res.items
        this.page.total = res.totalCount
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
</style>
